import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BlogTags } from '@app/_shared/_enums/blog-tags';
import { SEO, IShopifyProduct } from '@app/_shared/_models';
import { BlogService, ProductService, SeoService } from '@app/_shared/_services';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IBlogPost } from '../_prismic/blog-post';
import { ImageComponent } from '../../_shared/_components/image/image.component';
import { ProductCardComponent } from '../../_shared/_components/product-card/product-card.component';
import { BlockQuoteComponent } from '../../_shared/_components/block-quote/block-quote.component';
import { AsyncPipe, UpperCasePipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-how-to-purge-hot-tub-with-ahh-some',
    templateUrl: './how-to-purge-hot-tub-with-ahh-some.component.html',
    styleUrls: ['./how-to-purge-hot-tub-with-ahh-some.component.scss'],
    imports: [NgxSpinnerComponent, ImageComponent, ProductCardComponent, BlockQuoteComponent, RouterLink, AsyncPipe, UpperCasePipe, DatePipe]
})
export class HowToPurgeHotTubWithAhhSomeComponent implements OnInit, OnDestroy {
  private readonly blogService = inject(BlogService);
  private readonly ngxSpinnerService = inject(NgxSpinnerService);
  private readonly productService = inject(ProductService);
  private readonly seoService = inject(SeoService);

  public seo: SEO = {
    image: 'https://mypoolhut.com/assets/images/dirty-hot-tub-about-to-be-purged.webp',
    metaDescription: `Step by step guide on how to purge your hot tub with Ahh-Some. Learn how to properly clean your hot tub with Ahh-Some products sold at My Pool Hut!`,
    metaTitle: `How to Purge Your Hot Tub with Ahh-Some`
  };
  public spinner$: Observable<NgxSpinner>;
  public product$: Observable<IShopifyProduct | undefined>;
  public blogPost!: IBlogPost;
  public ahhSome: IShopifyProduct | undefined;
  private readonly blogTags = BlogTags;
  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  constructor() {
    const ngxSpinnerService = this.ngxSpinnerService;

    this.spinner$ = ngxSpinnerService.spinnerObservable;
    this.product$ = this.productService.product$;
  }

  public async ngOnInit(): Promise<void> {
    this.seoService.setMetaData(this.seo);
    this.seoService.createCanonicalUrl('https://mypoolhut.com/blog/how-to-purge-hot-tub-with-ahh-some');

    await this.ngxSpinnerService.show();
    this.blogService.blogs$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async (blogs: Array<IBlogPost>) => {
        const index = blogs.findIndex(b => b.tag === this.blogTags.HOW_TO_PURGE_HOT_TUB_WITH_AHH_SOME);
        if (index > -1) {
          this.blogPost = blogs[index];
          await this.ngxSpinnerService.hide();
        } else {
          await this.blogService.loadBlogs();
        }
      });

    this.ahhSome = await this.productService.loadProductByHandle('ahh-some-hot-tub-jetted-bath-plumbing-and-jet-cleaner');
  }

  public ngOnDestroy(): void {
    this.seoService.removeCanonicalUrl();
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
